import { render, staticRenderFns } from "./PerfilListagem.vue?vue&type=template&id=1e7b5e28&scoped=true&"
import script from "./PerfilListagem.vue?vue&type=script&lang=js&"
export * from "./PerfilListagem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7b5e28",
  null
  
)

export default component.exports